import React from "react";
import { PageTableType, trafficLightLabel } from "../../../redux/Types";
import {
  ColumnStickyTypes,
  ColumnTypes,
  JustificationTypes,
  optionSubTypes,
} from "../../../util/table-view/TableTypes";

import store from "redux/Store";
import {
  __getTrackStatusByID,
  __setMessageId,
} from "../../../_clearance/utils/utils";
import { Badge } from "@material-ui/core";
import { styles } from "./Styles.css";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import IconButton from "@material-ui/core/IconButton";
import {
  editMessage,
  setEditMessageCB,
  setUsePopup,
} from "../../messages/redux/MessagesActions";
import {
  refreshEdit,
  refreshitems,
  updateTrackUsage,
} from "../../../redux/actions/MlLicFormContentActions";
import { _newMessage } from "../../messages/Utils";
import { attachmentTypes, messageTypes } from "../../messages/Const";
import { localRefreshTrackingMeta, __updateCfStatus } from "./Utils";
import ClearanceMenu from "../../../_clearance/components/wizardv2/ClearanceMenu";
import ClearanceDetails from "./ClearanceDetails";
import { AiFillWarning } from "react-icons/ai";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { __trackStatus } from "_clearance/definition/status";
import { MenuItem, Select } from "@material-ui/core";
import TrafficLightInfoBox from "_module/component/traffic-light-info-box/traffic-light-info-box";
import { deepCopyFunction } from "util/CommonFunc";
import LinkIcon from '@material-ui/icons/Link';

export default () => {
  const {
    clearanceRuntime,
    messages: { editing: editingMessage },
    mllicformcontent: { editing, items, episodeList },
    mllictrack: { postUpdating },
    clearanceRuntime: { runtime },
    orgRuntime: {
      runtime: { _trackMusicOrigins: trackOrigins },
    },
  } = store.getState();

  const getTrackUsage = () => {
    if (clearanceRuntime.loading) return [];

    let trackUsageParameter = null;
    let paramsList = deepCopyFunction(clearanceRuntime?.runtime?._params || []);

    if (
      editing &&
      paramsList.length &&
      clearanceRuntime?.runtime?._config?.CF_TRACK_USAGE_PARAMS?.length
    ) {
      let param = clearanceRuntime.runtime._config.CF_TRACK_USAGE_PARAMS.find(
        (p) => p.type === editing.clearanceFormType
      );
      trackUsageParameter = paramsList.find((p) => p.id === param?.id);
    }

    return [...(trackUsageParameter?.options ?? []),{id: "TI", label: "Migrated - Title"}, {id: "BG", label: "Migrated - Background"}] || [];
  };

  const getStatuses = () => {
    if (clearanceRuntime.loading) return [];
    let lreturn = [];
    (clearanceRuntime?.runtime?._statuses || [])
      .filter(
        (v) =>
          v.id !== __trackStatus.inprogress.id &&
          v.id !== __trackStatus.norule.id
      )
      .map((v) => {
        lreturn.push({
          id: v.id,
          label: v.name,
        });
      });
    lreturn = [...lreturn, { id: "0", label: "Clear Me" }];
    return lreturn;
  };

  const loadMessage = (e, rowData, editing) => {
    e.stopPropagation();

    store.dispatch(setUsePopup(true));

    const {
      orgRuntime: {
        runtime: { _trackFields: trackFields },
      },
    } = store.getState();

    if (rowData.messageid) {
      store.dispatch(setEditMessageCB(null));
      store.dispatch(editMessage({ id: rowData.messageid }));
      store.dispatch(refreshitems(items));
      // COMMENTED THIS SECTION / REASON: MESSAGE DISPLAY IS A DIALOG BOX, NO NEED THIS CALLBACK/ ML20-3008
      // store.dispatch(
      //   closeMessageCB((closed) => {
      //     if (closed) {
      //       store.dispatch(refreshitems(items));
      //     }
      //   })
      // );
    } else {
      store.dispatch(refreshitems(items));
      store.dispatch(
        setEditMessageCB((id) => {
          let index = items.findIndex((v) => v.id === rowData.id);
          let nitems = [...items];
          if (index >= 0) {
            nitems[index].messageid = id;
            store.dispatch(refreshitems(nitems));
            __setMessageId(editing.clearance, rowData.id, id);
            let nediting = localRefreshTrackingMeta(editing);
            store.dispatch(refreshEdit(nediting));
          }
        })
      );

      store.dispatch(
        editMessage(
          _newMessage(
            messageTypes.CLEARANCE_TRACK,
            [
              {
                cfid: editing.id,
                cfname: editing.name,
                id: rowData.id,
                title: rowData[trackFields.trackTitle.id],
                artist: rowData[trackFields.performer.id],
                artwork: rowData[trackFields.prodArtworkUrl.id],
                type: attachmentTypes.CLEARANCE_FORM_TRACK,
              },
            ],
            editing.name + ", " + rowData[trackFields.trackTitle.id],
            "",
            // [editing?.createdBy],
            []
            // [defaultGroups.CLEARANCE_GROUP]
          )
        )
      );
    }
  };

  let columns = [
    {
      field: "selector",
      width: 23,
      type: ColumnTypes.selector,
      alignHeader: JustificationTypes.center,
      alignCell: JustificationTypes.center,
      sticky: ColumnStickyTypes.left,
      cellProp: (rowData) => {
        let hideContent = (editing?.clearance?.replacedTracks && editing?.clearance?.replacedTracks[rowData.trackDetails.id]) ? true :false;
        return { ...(hideContent ? { hideContent: true } : {}) };
      },
    },
    // {
    //   field: "",
    //   width: 20,
    //   type: ColumnTypes.thumb,
    //   alignHeader: JustificationTypes.center,
    //   alignCell: JustificationTypes.center,
    //   tablePageType: PageTableType.CLEARANCE_TRACKS,
    //   cellRenderer: (rowData) => (
    //     <Avatar
    //       variant={"square"}
    //       className={styles.tableArtwork}
    //       src={rowData[_trackFields.prodArtworkUrl.id]}
    //       alt={rowData[_trackFields.trackTitle.id]}
    //       title={rowData[_trackFields.trackTitle.id]}
    //     >
    //       {rowData[_trackFields.trackTitle.id]?.charAt(0)?.toUpperCase()}
    //     </Avatar>
    //   ),
    // },
    // {
    //   field: "",
    //   width: 6,
    //   type: ColumnTypes.player,
    //   alignHeader: JustificationTypes.center,
    //   alignCell: JustificationTypes.center,
    //   tablePageType: PageTableType.CLEARANCE_TRACKS,
    //   cellRenderer: (rowData) => (
    //     <PlayerRef key={rowData.id} aria-label="Play" item={rowData} />
    //   ),
    // },

    {
      field: "",
      width: 30,
      alignHeader: JustificationTypes.center,
      alignCell: JustificationTypes.center,
      sticky: ColumnStickyTypes.left,
      type: ColumnTypes.playerAndThumb,
      // tablePageType: PageTableType.CLEARANCE_FORM_TRACKS,
      cfTrack: true,
      cellProp: (rowData) => {
        const {
          orgRuntime: {
            runtime: { _trackFields: _trackFields },
          },
        } = store.getState();

        let showLinkIcon = (editing?.clearance?.replacedTracks && editing?.clearance?.replacedTracks[rowData.trackDetails.id]) ? true :false;

        return {
          artworkProps: {
            title: rowData.trackDetails[_trackFields.trackTitle.id],
            alt: `Art work for ${
              rowData.trackDetails[_trackFields.trackTitle.id]
            }`,
            variant: "square",
            src: rowData.trackDetails[_trackFields.prodArtworkUrl.id],
          },
          playerProps: {
            key: rowData.trackDetails.id,
            ariaLabel: `Play track ${
              rowData.trackDetails[_trackFields.trackTitle.id]
            }`,
            item: {
              ...rowData.trackDetails,
              ...(rowData?.trackDetails?.skyMlId
                ? { id: rowData?.trackDetails?.skyMlId }
                : {}),
            },
            postUpdating: postUpdating,
            mlCreated: rowData.trackDetails.mlCreated
              ? rowData.trackDetails.mlCreated
              : false,
          },
          ...(showLinkIcon ? { customIcon: ()=>{return(<LinkIcon />)} } : {}),
        };
      },
    },

    // {
    //   field: "",
    //   label: "",
    //   width: 12,
    //   alignHeader: JustificationTypes.center,
    //   alignCell: JustificationTypes.center,
    //   cellRenderer: (rowData) => (
    //     <>
    //       <IconButton
    //         className={styles.clearanceButtonMargin}
    //         title={"Messages"}
    //         aria-label="Load Message"
    //         onClick={(e) => {
    //           loadMessage(e, rowData.trackDetails, editing);
    //         }}
    //         disabled={
    //           !editing.id ||
    //           (editingMessage &&
    //             rowData.trackDetails.messageid &&
    //             editingMessage?.id === rowData.trackDetails.messageid) ||
    //           (runtime && runtime._config && editing[runtime._config.MIGRATED_FLAG]) || false
    //         }
    //       >
    //         <Badge
    //           class="clIconsmsg"
    //           color="secondary"
    //           variant="dot"
    //           invisible={rowData.messageid ? false : true}
    //         >
    //           <EmailOutlinedIcon />
    //         </Badge>
    //       </IconButton>
    //     </>
    //   ),
    // },
    ...(editing &&
    runtime?._config?.MIGRATED_FLAG &&
    editing[runtime._config.MIGRATED_FLAG] &&
    editing?.mlData?.skyMasterRef
      ? [
          {
            field: "clearanceFormId",
            label: "S",
            altTitle: "Is Series?",
            width: 30,
            alignHeader: JustificationTypes.center,
            alignCell: JustificationTypes.center,
            isSortable: editing[runtime._config.MIGRATED_FLAG] ? false : true,
            isFilterable: editing[runtime._config.MIGRATED_FLAG] ? false : true,
            type: ColumnTypes.options,
            filterOptions: [
              {
                id: editing.selectedMasterFormId,
                label: "Series",
              },
              {
                id: editing.id,
                label: "Episode",
              },
            ],
            cellRenderer: (rowData) => (
              <>
                {rowData.clearanceFormId === editing.id ? (
                  ""
                ) : (
                  <Link
                    aria-label={`Navigate to series master form`}
                    key={rowData.id}
                    to={`/mllicensingforms/${rowData.clearanceFormId}`}>
                    <span title="Series Master" className="seriesIndicator">
                      S
                    </span>
                  </Link>
                )}
              </>
            ),
          },
        ]
      : []),

    // ...(editing.master ? [{
    //   field: "allEpisodes",
    //   label: "All Episodes",
    //   altTitle: "All Episodes",
    //   width: 130,
    //   alignHeader: JustificationTypes.left,
    //   alignCell: JustificationTypes.left,
    //   isSortable: true,
    //   isFilterable: true,
    //   type: ColumnTypes.options,
    //   filterOptions: [
    //     {
    //       id: true,
    //       label: "Yes",
    //     },
    //     {
    //       id: false,
    //       label: "No",
    //     }
    //   ],
    //   cellRenderer: (rowData) => (
    //     <>
    //       {rowData.allEpisodes ? "Yes" : "No"}
    //     </>
    //   ),
    // }] : []),
    {
      field: "trackDetails.skyTracfficLight",
      label: "TL",
      width: 20,
      alignHeader: JustificationTypes.left,
      alignCell: JustificationTypes.center,
      type: ColumnTypes.options,
      subType: optionSubTypes.optionWithColor,
      isFilterable: false,
      isSortable: true,
      filterOptions: trafficLightLabel.map((item) => {
        return { id: item.id, label: item.desc };
      }),
      cellRenderer: (rowData) => {
        if (
          rowData &&
          rowData["trackDetails"] &&
          (rowData["trackDetails"].skyTracfficLight ||
            rowData["trackDetails"].skyTracfficLight == 0)
        ) {
          return (
            <>
              <TrafficLightInfoBox
                data={
                  rowData["trackDetails"].skyTracfficLight
                }></TrafficLightInfoBox>
            </>
          );
        }
      },
      cellProp: (rowData) => {
        let trafficLight = trafficLightLabel.find(
          (item) => item.id === rowData?.trackDetails?.skyTracfficLight
        );
        return {
          accessDataProps: {
            title: trafficLight ? trafficLight.desc : "",
          },
        };
      },
    },
    {
      field: "trackDetails.trackTitle",
      label: "TRACK DETAILS",
      width: 300,
      isSortable: true,
      isFilterable:
        runtime && editing && editing[runtime._config.MIGRATED_FLAG]
          ? false
          : true,
      type: ColumnTypes.string,
      cellRenderer: (rowData) => {
        const {
          orgRuntime: {
            runtime: { _trackFields: _trackFields },
          },
        } = store.getState();

        return (
          <div title={`${rowData["trackDetails"][_trackFields.trackTitle.id]}`}>
            <div class="clearanceTrackDetails">
              {rowData["trackDetails"][_trackFields.trackTitle.id]}
            </div>
            <div class="clearanceTrackArtist">
              {Array.isArray(rowData["trackDetails"][_trackFields.performer.id])
                ? rowData["trackDetails"][_trackFields.performer.id].join(", ")
                : rowData["trackDetails"][_trackFields.performer.id]}
            </div>
          </div>
        );
      },
    },
    {
      field: "origin",
      label: "ORIGIN",
      width: 150,
      type: ColumnTypes.options,
      isSortable: true,
      isFilterable:
        runtime && editing && editing[runtime._config.MIGRATED_FLAG]
          ? false
          : true,
      filterOptions: Object.values(trackOrigins),
      cellRenderer: (rowData) => {
        return (
          <>
            <b
              title={
                // Object.values(trackOrigins).find((e) => rowData.origin === e.id)
                Object.values(trackOrigins).find((e) => rowData["trackDetails"]["musicOrigin"] === e.id)
                  ?.label || ""
              }>
              {" "}
              {/* {Object.values(trackOrigins).find((e) => rowData.origin === e.id) */}
              {Object.values(trackOrigins).find((e) => rowData["trackDetails"]["musicOrigin"] === e.id)
                ?.label || ""}{" "}
            </b>
          </>
        );
      },
    },
    {
      field: "clearancestatus",
      label: "CLEARANCE STATUS",
      width: 170,
      isSortable: true,
      isFilterable:
        runtime && editing && editing[runtime._config.MIGRATED_FLAG]
          ? false
          : true,
      type: ColumnTypes.options,
      filterOptions: getStatuses(),
      cellRenderer: (rowData) => {
        let disableMenu = (editing?.clearance?.replacedTracks && editing?.clearance?.replacedTracks[rowData.trackDetails.id]) ? true :false;
        return (
          <>
            <ClearanceMenu
              isSeriesTrack={
                !(rowData.clearanceFormId === editing?.id) ||
                editing?.programmeType ===
                  runtime?._config?.PROGRAMME_TYPES.EPISODE
              }
              isMasterForm={editing?.master}
              focusTrack={rowData}
              refreshDownloadLink={true}
              fromCfBy={editing?.createdBy}
              disableMenu={disableMenu}
            />
            {runtime?._config?.COLLISIONS &&
            !isNaN(rowData.clearancestatus) &&
            +rowData.clearancestatus ===
              runtime._config.COLLISIONS.cfTrackStatus &&
            rowData.collision ? (
              <AiFillWarning
                class="redIcon"
                style={{
                  fontSize: "20px",
                  verticalAlign: "middle",
                  marginLeft: "5px",
                }}
                title="Track Collision Detected."
              />
            ) : (
              ""
            )}
          </>
        );
      },
    },
    // ...((editing[runtime._config.MIGRATED_FLAG] && editing.clearanceFormType !== runtime?._config?.CLEARANCE_FORM_TYPE.PROMO) ? [{
    //   field: "usageDesc",
    //   label: "USAGE",
    //   width: 150,
    //   type: ColumnTypes.options,
    //   alignHeader: JustificationTypes.center,
    //   alignCell: JustificationTypes.center,
    //   isSortable: editing[runtime._config.MIGRATED_FLAG]?false:true,
    //   isFilterable: editing[runtime._config.MIGRATED_FLAG]?false:true,
    //   filterOptions: getTrackUsage(),
    //   cellRenderer: (rowData) => {
    //     return (<>{rowData?.usageDesc}</>)
    //   },
    // }] : []),
    {
      field: "",
      label: "",
      width: 30,
      alignHeader: JustificationTypes.center,
      alignCell: JustificationTypes.center,
      sticky: ColumnStickyTypes.left,
      type: ColumnTypes.string,
      tablePageType: PageTableType.CLEARANCE_FORM_TRACKS,
      cellRenderer: (rowData) => {
        return <ClearanceDetails focusTrack={rowData} />;
      },
    },
    ...(editing?.clearanceFormType ===
      runtime?._config?.CLEARANCE_FORM_TYPE.PROGRAMMING &&
    editing?.programmeType !== runtime?._config?.PROGRAMME_TYPES.ONEOFF &&
    !editing[runtime._config.MIGRATED_FLAG]
      ? [
          {
            field: "trackEpisodes",
            label: "EPISODE(S)",
            width: 65,
            type: ColumnTypes.number,
            isSortable: false,
            isFilterable: false,
            cellRenderer: (rowData) => {
              return rowData?.trackEpisodes?.length > 0
                ? rowData.trackEpisodes.length
                : "";
            },
            cellProp: (rowData) => {
              const titleList = episodeList?.reduce((acc, ep) => {
                if (rowData?.trackEpisodes?.includes(ep.id)) {
                  acc.push(ep.episodeTitle);
                }
                return acc;
              }, []);
              const tooltipContent =
                titleList?.length > 0 ? titleList.join(" / ") : "";
              return {
                accessDataProps: {
                  title: `${tooltipContent}`,
                },
              };
            },
          },
        ]
      : []),
    ...(editing &&
    editing?.clearanceFormType !==
      runtime?._config?.CLEARANCE_FORM_TYPE.PROMO &&
    !editing[runtime._config.MIGRATED_FLAG]
      ? [
          {
            field: "trackUsage",
            label: "Usage",
            width: 150,
            type: ColumnTypes.options,
            isSortable: true,
            isFilterable: true,
            cellRenderer: (rowData) => {
              return (
                getTrackUsage()?.find(
                  (u) =>
                    u.id === (rowData?.trackUsage || rowData?.usage) && rowData?.clearancestatus
                )?.label || ""
              );
            },
            filterOptions: getTrackUsage(),
          },
        ]
      : []),
    {
      field: "menu",
      width: 30,
      type: ColumnTypes.menu,
      sticky: ColumnStickyTypes.right,
      tablePageType: PageTableType.CLEARANCE_FORM_TRACKS,
      cellProp: (rowData) => {
        let hideContent = (editing?.clearance?.replacedTracks && editing?.clearance?.replacedTracks[rowData.trackDetails.id]) ? true :false;
        return { ...(hideContent ? { hideContent: true } : {}) };
      },
    },
  ];

  // if(!editing?.master){
  //   columns = columns.filter(c => c.field !== 'episodes');
  // }

  return columns;
};
